import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { useRsmTheme } from '../../hooks/useTheme.js';

/**
 * Featured eBook section displaying the October 2025 book
 *
 * @returns {React.ReactElement} Featured eBook section component
 */
const FeaturedEBookSection = memo(function FeaturedEBookSection() {
  const { colors, shadows } = useRsmTheme();

  return (
    <Box sx={{ mb: 6 }}>
      {/* biome-ignore lint/correctness/useUniqueElementIds: Static ID needed for anchor linking */}
      <Box
        id="october-2025"
        sx={{
          backgroundColor: colors.background,
          borderRadius: '12px',
          p: { xs: 3, md: 5 },
          mb: 6,
          boxShadow: shadows.card,
          position: 'relative',
          border: `1px solid ${colors.grey200}`,
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -1,
            left: -1,
            width: '60px',
            height: '60px',
            borderTop: `4px solid ${colors.primary}`,
            borderLeft: `4px solid ${colors.primary}`,
            borderRadius: 0,
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -1,
            right: -1,
            width: '60px',
            height: '60px',
            borderBottom: `4px solid ${colors.primary}`,
            borderRight: `4px solid ${colors.primary}`,
            borderRadius: 0,
          },
        }}
      >
        <Typography
          variant="h4"
          sx={{ color: colors.textPrimary, fontWeight: 600, mb: 2 }}
        >
          Value Add Billing: On-Ramp to FinOps-as-a-Service
        </Typography>
        <Typography sx={{ color: colors.primary, fontWeight: 600, mb: 3 }}>
          Expected Release: October 2025
        </Typography>
        <Typography
          paragraph
          sx={{
            color: colors.textLight,
            fontSize: '1.1rem',
            lineHeight: 1.8,
            mb: 3,
          }}
        >
          A comprehensive guide to transforming your billing practices and
          embracing Financial Operations excellence. Learn how to implement
          strategic billing practices that add value rather than just tracking
          costs.
        </Typography>
        <Typography
          variant="h5"
          sx={{ color: colors.primary, fontWeight: 600, mb: 2 }}
        >
          What You'll Learn:
        </Typography>
        <Box
          component="ul"
          sx={{
            color: colors.textLight,
            fontSize: '1.1rem',
            lineHeight: 1.8,
            pl: 3,
          }}
        >
          <li>Understanding FinOps principles and practices</li>
          <li>Implementing value-add billing strategies</li>
          <li>Cost optimization and visibility techniques</li>
          <li>Building a culture of cost awareness</li>
        </Box>
      </Box>
    </Box>
  );
});

export default FeaturedEBookSection;
